import styled from 'styled-components';

export const Container = styled.div`
	width: 100vw;

	display: flex;
	align-items: center;
	flex-direction: column;
`;
